/**
 * Removes all non-numeric characters from a document string
 * @param document - The document string to sanitize
 * @returns Clean numeric string
 */
export const normalizeDocument = (doc: string): string => {
  if (!doc) return "";
  return doc.replace(/\D/g, "");
}